import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'markdown-to-jsx';

import { Button } from '@ynap/button';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('TcMessage');

const getTrackingMethod = (linkUrl, onPrivacyClick, onTermsClick) => {
    if (linkUrl?.includes('privacy-policy')) {
        return onPrivacyClick;
    }

    if (linkUrl?.includes('terms-and-conditions')) {
        return onTermsClick;
    }
};

const TcMessage = ({ className, messages, onPrivacyClick, onTermsClick, localeId }) => {
    return (
        <ReactMarkdown
            className={bem('terms', null, className)}
            options={{
                forceBlock: true,
                overrides: {
                    a: (props) => {
                        const { href, children } = props;
                        const trackingMethod = getTrackingMethod(href, onPrivacyClick, onTermsClick);
    
                        return (
                            <Button type="link" component="a" href={href} target="_blank" rel="noopener" className={bem('tandc')} onClick={trackingMethod}>
                                {children}
                            </Button>
                        );
                    },
                },
            }}
        >
            {messages.registrationForm?.termsAndConditionsAcceptance?.({ locale: localeId })}
        </ReactMarkdown>
    );
};

TcMessage.propTypes = {
    className: PropTypes.string,
    messages: PropTypes.shape({
        registrationForm: PropTypes.shape({
            termsAndConditionsAcceptance: PropTypes.func,
            termsAndConditionsRewardsProgram: PropTypes.func,
        }).isRequired,
    }).isRequired,
    onPrivacyClick: PropTypes.func,
    onTermsClick: PropTypes.func,
    localeId: PropTypes.string,
};

export default TcMessage;
